import {
  ROUTE_INITIAL_QUESTION_PAGE,
  ROUTE_ABOUT_YOUR_APPLICATION_PAGE,
  ROUTE_APPLICATION_SUBMISSION_PAGE,
  ROUTE_RESUME_PAGE,
  ROUTE_USERNAME_PASSWORD_PAGE,
  NAVIGATE_TO_CD,
  CASE_TYPE_EXISTING,
  ROUTE_PERSONAL_INFO_PAGE,
  ROUTE_SIGNIFICANT_PEOPLE_PAGE,
  APPLICANT_FLOW,
  ROUTE_REVIEW_PAGE,
  ROUTE_ADDITIONAL_PRODUCT_PAGE,
  ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE,
  ROUTE_IDV_QUESTION_PAGE,
  ROUTE_INFO_SECTION,
  ROUTE_CHECK_IDENTITY_PAGE,
  ROUTE_DEFERRED_PAGE,
  ROUTE_SECURITY_CHECKS_PAGE,
  ROUTE_TECH_ERROR,
  ROUTE_PRIMARY_APPLICANT_WAITING,
  ROUTE_APPLICATION_COMPLETE_PAGE,
  ROUTE_BEGIN_YOUR_APPLICATION_PAGE,
  ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE,
  ROUTE_PENDING_STATEMENTS_FAIL_PAGE,
  ROUTE_PENDING_STATEMENTS_PAGE,
  ROUTE_SECONDARY_APPLICANT_WAITING,
  LETTER_CODE,
  ROUTE_ENTER_LINK_CODE,
  ROUTE_TO_INCORRECT_LINK_CODE,
  ROUTE_OPEN_BUSINESS_ACCOUNT_PAGE,
  ROUTE_ALMOST_THERE_PAGE,
  ROUTE_ALT_BUSINESS_ACCOUNT_PAGE,
  DECLINE,
  ROUTE_SWITCH_DATE_PAGE,
  ROUTE_OLD_ACCOUNT_DETAILS_PAGE,
  ROUTE_OLD_SIGNATORIES_PAGE,
  OFFER_PAGE,
  ROUTE_TO_IDV_CHALLENGE_ERROR,
  SET_UP_IN_PROGRESS_ERROR,
  ROUTE_INFORMATIVE_PAGE
} from '../utils/constants';
import { previousRoutePaths } from './routePathMapping';
import { caseType, getSingleEntry } from '../infrastructure/config/selectors';
import { isSoleTrader, getJointLinkCode } from '../infrastructure/cases/selectors';

const getBackNavigationRoute = (currentPath, state) => {
  const linkCode = getJointLinkCode(state);
  const isSole = isSoleTrader(state);
  const misMatchBankId = state.config.get('misMatchBankId');

  if (currentPath === ROUTE_SIGNIFICANT_PEOPLE_PAGE) {
    if (linkCode && !getSingleEntry(state, APPLICANT_FLOW)) {
      return ROUTE_REVIEW_PAGE;
    }
    return isSole ? ROUTE_ADDITIONAL_PRODUCT_PAGE : ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE;
  }
  if (currentPath === ROUTE_INFO_SECTION) {
    return linkCode ? ROUTE_SIGNIFICANT_PEOPLE_PAGE : ROUTE_REVIEW_PAGE;
  }

  if (currentPath === ROUTE_USERNAME_PASSWORD_PAGE) {
    return caseType(state) === CASE_TYPE_EXISTING ? ROUTE_PERSONAL_INFO_PAGE : NAVIGATE_TO_CD;
  }
  if (currentPath === ROUTE_SWITCH_DATE_PAGE) {
    return isSole ? ROUTE_OLD_ACCOUNT_DETAILS_PAGE : ROUTE_OLD_SIGNATORIES_PAGE;
  }
  if (misMatchBankId && currentPath === ROUTE_PERSONAL_INFO_PAGE) {
    return ROUTE_INFORMATIVE_PAGE;
  }
  return previousRoutePaths[currentPath];
};

const showHeaderUtility = currentPath => {
  const excludeHeaderPath = [
    ROUTE_ABOUT_YOUR_APPLICATION_PAGE,
    ROUTE_INITIAL_QUESTION_PAGE,
    ROUTE_APPLICATION_SUBMISSION_PAGE,
    ROUTE_RESUME_PAGE,
    ROUTE_CHECK_IDENTITY_PAGE,
    ROUTE_DEFERRED_PAGE,
    ROUTE_SECURITY_CHECKS_PAGE,
    ROUTE_PRIMARY_APPLICANT_WAITING,
    ROUTE_SECONDARY_APPLICANT_WAITING,
    ROUTE_PENDING_STATEMENTS_PAGE,
    ROUTE_PENDING_STATEMENTS_FAIL_PAGE,
    ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE,
    ROUTE_BEGIN_YOUR_APPLICATION_PAGE,
    ROUTE_APPLICATION_COMPLETE_PAGE,
    ROUTE_TO_IDV_CHALLENGE_ERROR,
    SET_UP_IN_PROGRESS_ERROR
  ];
  return !excludeHeaderPath.includes(currentPath);
};

const getHeaderAttribute = (currentPath, content, productName) => {
  const noBackButtonPaths = [
    ROUTE_ABOUT_YOUR_APPLICATION_PAGE,
    ROUTE_INITIAL_QUESTION_PAGE,
    ROUTE_TECH_ERROR,
    ROUTE_IDV_QUESTION_PAGE,
    LETTER_CODE,
    ROUTE_ENTER_LINK_CODE,
    ROUTE_TO_INCORRECT_LINK_CODE,
    ROUTE_OPEN_BUSINESS_ACCOUNT_PAGE,
    ROUTE_ALMOST_THERE_PAGE,
    ROUTE_ALT_BUSINESS_ACCOUNT_PAGE,
    DECLINE,
    OFFER_PAGE,
    ROUTE_BEGIN_YOUR_APPLICATION_PAGE,
    ROUTE_APPLICATION_COMPLETE_PAGE,
    ROUTE_INFORMATIVE_PAGE
  ];

  let headerText;
  const {
    initialQuestionsPageHeader,
    initialQuestionsPageOfferType,
    checkIdentityPageHeader,
    headerSubmission,
    applicationCompleteHeader,
    defaultBusinessHeader
  } = content;
  switch (currentPath) {
    case ROUTE_BEGIN_YOUR_APPLICATION_PAGE:
    case ROUTE_ABOUT_YOUR_APPLICATION_PAGE:
    case ROUTE_INITIAL_QUESTION_PAGE:
      headerText = `${initialQuestionsPageHeader} ${productName || initialQuestionsPageOfferType}`;
      break;
    case ROUTE_CHECK_IDENTITY_PAGE:
      headerText = checkIdentityPageHeader;
      break;
    case ROUTE_SECONDARY_APPLICANT_WAITING:
    case ROUTE_PENDING_STATEMENTS_PAGE:
    case ROUTE_PENDING_STATEMENTS_FAIL_PAGE:
    case ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE:
    case ROUTE_DEFERRED_PAGE:
    case ROUTE_PRIMARY_APPLICANT_WAITING:
      headerText = headerSubmission;
      break;
    case ROUTE_APPLICATION_COMPLETE_PAGE:
      headerText = applicationCompleteHeader;
      break;
    default:
      headerText = defaultBusinessHeader;
      break;
  }

  return {
    isBackNavigationNeeded: !noBackButtonPaths.includes(currentPath),
    headerText
  };
};

const getCurrentStep = currentPath => {
  const stepOnePaths = [
    ROUTE_ABOUT_YOUR_APPLICATION_PAGE,
    ROUTE_INITIAL_QUESTION_PAGE,
    ROUTE_BEGIN_YOUR_APPLICATION_PAGE
  ];
  const stepTwoPaths = [
    ROUTE_CHECK_IDENTITY_PAGE,
    ROUTE_DEFERRED_PAGE,
    ROUTE_PRIMARY_APPLICANT_WAITING,
    ROUTE_PENDING_STATEMENTS_PAGE,
    ROUTE_PENDING_STATEMENTS_FAIL_PAGE,
    ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE
  ];
  const stepThreePaths = [ROUTE_APPLICATION_COMPLETE_PAGE, ROUTE_SECONDARY_APPLICANT_WAITING];

  if (stepOnePaths.includes(currentPath)) {
    return '1';
  }
  if (stepTwoPaths.includes(currentPath)) {
    return '2';
  }
  if (stepThreePaths.includes(currentPath)) {
    return '3';
  }
  return null;
};

export { getBackNavigationRoute, getHeaderAttribute, getCurrentStep, showHeaderUtility };
